import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes } from "react-router-dom";
// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import { persistQueryClient } from "@tanstack/query-persist-client-core";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import axios from "axios";
import { SnackbarProvider } from "notistack";
import React, { Suspense, lazy, useState } from "react";
import { Route } from "react-router-dom";
import { AppProvider } from "./AppContext";
import AppInitializer from "./AppInitializer";
import LoginProtected from "./components/LoginProtected";
import ProtectedRoute from "./components/ProtectedRoute";
import Spinner from "./components/Spinner";
import ScrollToTop from "./components/scroll-to-top";
import appConfig from "./config";
import { PosProvider } from "./shared/PosContext";

// import LoginPage from "./pages/LoginPage";
const LoginPage = lazy(() => import("./pages/Login"));

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnMount: false,
            refetchOnReconnect: true,
            refetchOnWindowFocus: false,
            cacheTime: 0,
            // enabled: !!localStorage.getItem("accessToken"),
        },
    },
});

axios.interceptors.request.use(
    (config) => {
        config.withCredentials = true;
        config.crossDomain = true;
        config.baseURL = appConfig.apiBaseUrl;

        let token = localStorage.getItem("accessToken");

        if (token) {
            // config.headers["Authorization"] = `${token}`;
        }
        config.headers["Content-Type"] = "application/json";
        config.headers["Access-Control-Allow-Credentials"] = true;
        config.headers["Accept"] = "application/json";

        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

const persister = createSyncStoragePersister({
    storage: window.localStorage,
});

// persistQueryClient({
//     queryClient,
//     persister: persister,
// });

export default function App() {
    // Status useState for store user loggedIn and did user logout

    // const [status, setStatus] = useState(() => {
    //     const token = localStorage.getItem("token");
    //     if (!token) {
    //         return { loggedIn: false, didLogout: false };
    //     } else {
    //         return { loggedIn: true, didLogout: false };
    //     }
    // });

    return (
        <>
            <QueryClientProvider client={queryClient}>
                {/* <DisablePullToRefresh /> */}
                <HelmetProvider>
                    <BrowserRouter>
                        <SnackbarProvider maxSnack={5}>
                            <ThemeProvider>
                                <ScrollToTop />
                                <Routes>
                                    {/*Login Page */}
                                    <Route
                                        path="/login"
                                        element={
                                            <Suspense fallback={<Spinner />}>
                                                <LoginProtected>
                                                    <LoginPage />
                                                </LoginProtected>
                                            </Suspense>
                                        }
                                    />
                                    <Route
                                        path="*"
                                        element={
                                            <ProtectedRoute>
                                                <AppProvider>
                                                    <PosProvider>
                                                        <AppInitializer>
                                                            <Router />
                                                        </AppInitializer>
                                                    </PosProvider>
                                                </AppProvider>
                                            </ProtectedRoute>
                                        }
                                    />
                                </Routes>
                            </ThemeProvider>
                        </SnackbarProvider>
                    </BrowserRouter>
                </HelmetProvider>
                {/* <ReactQueryDevtools initialIsOpen={false} position='bottom-right' /> */}
            </QueryClientProvider>
        </>
    );
}
